import { TypeOptions } from 'react-toastify'

interface BHTagProps {
  className?: string
  status: TypeOptions
  text: string
}

function BHTag({ className, status, text }: BHTagProps) {
  let colorClass = ''
  switch (status) {
    case 'info':
      colorClass = 'bg-blue-200'
      break
    case 'warning':
      colorClass = 'bg-yellow-200'
      break
    case 'success':
      colorClass = 'bg-green-200'
      break
    case 'error':
      colorClass = 'bg-red-200'
      break
    default:
      colorClass = 'bg-gray-200'
      break
  }

  if (className === undefined) className = '';

  return (
    <span
      className={`rounded-full whitespace-nowrap px-4 py-1 text-xs font-normal ${colorClass} ${className && className
        }`}
    >
      {text}
    </span>
  )
}

export default BHTag
